import { Component, Input, OnInit } from '@angular/core';

import { AlertService } from '../../shared/services/alert.service';
import { AuthService } from '../../shared/services/auth.service';
import { LoginComponent } from '../login.component';
import { UserService } from '../../shared/services/user.service';

import { Params, Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { StorageService } from '../../shared/services/storage.service';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  public result: any;
  public returnurl: string;
  public authurl: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private userService: UserService,
    private afdb: AngularFireDatabase,
    private storageService: StorageService, private afAuth: AngularFireAuth
  ) { }


  ngOnInit() {

    if (this.storageService.getItem('userid') === null || this.storageService.getItem('userid') === 'null') {
      console.log("auth.component ---> user is not authenticated");

      // not logged in so redirect to login page with the return url and return false
      this.returnurl = this.route.snapshot.queryParams["redirect_uri"];
      this.router.navigate(['/login/forumauth'], { queryParams: { redirect_uri: this.returnurl } });

    } else {

      this.getTokenAndRedirect(this.returnurl);
    }

  }


  getTokenAndRedirect(returnUrl: string) {

    let returnurl = this.route.snapshot.queryParams['redirect_uri'] || '/orgsearch';
    var accesstoken = this.storageService.getItem('tokenId') || '';
    var authUrl = returnurl + "?token=" + accesstoken
    // login successful so redirect to return url
    console.log(" auth uri --> " + authUrl)
    window.location.href = authUrl


  }

}




// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/auth/auth.component.ts